import { SegmentSource } from '@pushly/aqe/lib/enums/segment-source'

export class SegmentDto {
    public static parse(fields: SegmentDto): SegmentDto {
        const dto = new SegmentDto()

        type AllowedType = keyof SegmentDto
        const fieldsToAssign: AllowedType[] = [
            'id',
            'computed_status',
            'domain_id',
            'name',
            'source',
            'is_default',
            'topic_name',
            'filters_json',
            'treatment_spec',
            'estimated_reach',
            'iron_url',
            'group',
            'last_targeted_date_utc',
            'created_at',
            'created_by',
            'created_by_user_name',
            'destroyed_at',
        ]

        fieldsToAssign.forEach((key) => {
            if (fields[key] !== undefined) {
                // @ts-ignore
                dto[key as any] = fields[key]
            }
        })

        return dto
    }

    public id: number
    public computed_status: string
    public domain_id: number
    public name: string
    public source: SegmentSource
    public is_default: boolean
    public topic_name: string
    public iron_url?: string
    public filters_json: any
    public treatment_spec: any
    public estimated_reach: number | null
    public last_targeted_date_utc?: Date
    public group?: any
    public created_at: Date
    public created_by: number
    public created_by_user_name?: string
    public destroyed_at?: Date
}
